import { getAppConfig } from 'config/appConfig';
import { STORAGE_KEYS } from 'constants/storageKeys';
import { tenantStorage } from 'utils/tenantStorage';

const catalogConfigService = {
  getDefaultLocale: () => tenantStorage.getItem(STORAGE_KEYS.LOCALE) || getAppConfig()?.defaultLocale || 'es-AR',
  getDefaultCurrency: () => tenantStorage.getItem(STORAGE_KEYS.CURRENCY) || getAppConfig()?.defaultCurrency || 'ARS',
  setLocale: (locale: string) => tenantStorage.setItem(STORAGE_KEYS.LOCALE, locale),
  setCurrency: (currency: string) => tenantStorage.setItem(STORAGE_KEYS.CURRENCY, currency),
};

export default catalogConfigService;
